import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import {
  NormalSelect,
  NormalButton,
  NormalTable,
  NormalCheckbox,
} from "component/common";
import { Tab } from "component/common";
import { history } from "helpers";
import { getCommonApi } from "redux/actions/common";

export class ReportSettingsClass extends Component {
  state = {
    ReportHeader: [
      { label: "CODE", divClass: "justify-content-center text-center" },
      { label: "NAME" },

      {
        label: "AUTHORIZATION",
        divClass: "d-flex justify-content-around w-100",
      },
    ],
    authorization: false,
    customer: [],
    CustomerOptions: [],
  };
  updateState = async (data) => {
    if (this.state.isMounted) this.setState(data);
  };
  onChange = (e) => {
    this.updateState({ [e.target.name]: e.target.value });
  };
  // Selected_data = () => {
  //   let { emp_codeid, CustomerOption } = this.state;
  //   this.props
  //     .getCommonApi(`empcartlist/?sales_staff=1&page=1&limit=12`)
  //     .then((e) => {
  //       this.setState({
  //         CustomerOptions: e.data?.dataList.map((e) => {
  //           return { label: e.emp_name, value: e.id };
  //         }),
  //       });
  //     });
  //   this.setState({ CustomerOption, emp_codeid });
  //   console.log(CustomerOption, "helo");
  // };
  // componentDidMount() {
  //   this.Selected_data();
  // }
  render() {
    const customerOptions = [
      {
        label: "ALEX GAN",
        value: "ALEX GAN",
      },
      {
        label: "CAROL",
        value: "CAROL",
      },
      {
        label: "DIVYA",
        value: "DIVYA",
      },
      {
        label: "KAREN",
        value: "KAREN",
      },
      {
        label: "LEE WEE",
        value: "LEE WEE",
      },
      {
        label: "MARY",
        value: "MARY",
      },
      {
        label: "MAYA",
        value: "MAYA",
      },
      {
        label: "SHEENA",
        value: "SHEENA",
      },
      {
        label: "waiting list",
        value: "waiting list",
      },
    ];
    const UserAuthorization = [
      {
        code: "R10044",
        text: "Expired Invoice Report",
        id: 1,
      },
      {
        code: "R10050",
        text: "Sale Collection Prd Svc",
        id: 2,
      },
      {
        code: "R10053",
        text: "Top Sales Product",
        id: 3,
      },
      {
        code: "R10050",
        text: "Treatment Anaysis",
        id: 4,
      },
      {
        code: "R10053",
        text: "Reversal to CN",
        id: 5,
      },
      {
        code: "R10050",
        text: "Product Usage",

        id: 6,
      },
      {
        code: "R10053",
        text: "Outlet Month Performance",

        id: 7,
      },
      {
        code: "R10050",
        text: "Outlet Target Vs Actual",

        id: 8,
      },
    ];
    return (
      <>
        <div className="col-12">
          <div className="container-fluid bg-white px-md-5 my-3">
            <div className="py-5 px-md-5">
              <p className="fs-16">
                <span className="font-weight-bold px-1 ">HOME</span>/SETTINGS
              </p>

              <h1 className="my-4 reports-heading">Settings</h1>
              <div className="row my-4">
                <div className="col-8">
                  <p className="fs-18 fw-600">List of Reports</p>
                </div>

                <div className="col-4 d-flex">
                  <h6 className="mx-4 my-2">USER</h6>
                  <NormalSelect
                    options={customerOptions}
                    className="customer-name py-1"
                    // value={this.state.customer}
                    // onChange={this.onChange}
                    // name="customer"
                    // placeholder="customer"
                    // required
                  />
                </div>
              </div>
              <div className="row">
                <div className="table-container table-responsive mt-3">
                  <NormalTable headerDetails={this.state.ReportHeader}>
                    {UserAuthorization && UserAuthorization.length > 0 ? (
                      UserAuthorization.map((item, index) => {
                        return (
                          <tr className="w-100" key={index}>
                            <td className="fs-16">
                              <div className="text-left text-start w-75  justify-content-center text-center">
                                {item.code}
                              </div>
                            </td>
                            <td className="fs-16">
                              <div className="text-left">{item.text}</div>
                            </td>
                            <td>
                              <div className="d-flex justify-content-around">
                                <NormalCheckbox
                                  checked={this.state.authorization}
                                  value={this.state.authorization}
                                  name="authorization"
                                  // onChange={(e) =>
                                  //   this.handleCheckbox(e, index)
                                  // }
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="w-100">
                        <td colSpan="12">
                          <div className="d-flex align-items-center justify-content-center">
                            {"No Data Available"}
                          </div>
                        </td>
                      </tr>
                    )}
                  </NormalTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

// const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
    },
    dispatch
  );
};

export const ReportSettings = withTranslation()(
  connect(null, mapDispatchToProps)(ReportSettingsClass)
);
